import styled, {css} from 'styled-components'

export const StyledFormRoot = styled.form`
    ${({theme: {palette, typography, spacing}}) => css`
        ${typography.textM};
        color: ${palette.gray.middle};
        display: grid;
        gap: ${spacing * 7}px;
        & span {
            font-weight: 500;
        }
    `}
`
